var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.buildings),function(ref){
var id = ref.id;
var token = ref.token;
var name = ref.name;
var group = ref.group;
return _c('simple-list-li',{key:token,attrs:{"id":id,"token":token,"name":name}},[_c('router-link',{staticClass:"flex justify-between leading-loose rounded py-2 px-4 hover__bg-primary-400-10",attrs:{"to":{ name: 'building-details', params: { groupId: group.id, buildingId: id } }}},[_c('span',{staticClass:"truncate pr-6"},[_vm._v(_vm._s(name))]),_c('span',{staticClass:"text-right text-gray-600"},[_vm._v(_vm._s(token))])])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }